var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about-chloe"},[_c('p',[_vm._v("\n        "+_vm._s(_vm.$translate('about_chloe_report'))+"\n    ")])])}
var staticRenderFns = []
export { render, staticRenderFns }